import React from 'react';
import { enCurrency } from 'interfaces/IProductData';
import currencyFormatter from 'currency-formatter';
import { BaseComponent } from 'components/BaseComponent';
import { currencyService } from 'services/CurrencyService';
import { IStateBase } from './BaseComponent';

interface ICurrencyFormatProps {
  value: number;
}

interface IState extends IStateBase {
  currency: enCurrency;
}

export class CurrencyFormat extends BaseComponent<IState, ICurrencyFormatProps> {

  componentDidMount() {
    this.observeState({ currency: null }, currencyService.getCurrency());
  }

  render() {

    if (!this.state) {
      return null;
    }

    const { currency } = this.state;

    const value = currencyFormatter.format(this.props.value, { code: currency, precision: 2 });

    return (<span>{value}</span>);
  }

}



// WEBPACK FOOTER //
// ./src/components/CurrencyFormat.tsx